export default "__VITE_ASSET__BattSiZh__"